mutation UpdateCameraControl(
  $camControlId: ID!
  $name: String
  $broadcasterUserIds: [String!]
  $commands: [StreamToolsCameraCommandInput!]
  $changeLimit: Int
  $cooldownMs: Int
  $counterMode: String
  $youtubeVotesEnabled: Boolean
) {
  camControl: StreamToolsUpdateCameraControl(
    camControlId: $camControlId
    name: $name
    broadcasterUserIds: $broadcasterUserIds
    commands: $commands
    changeLimit: $changeLimit
    cooldownMs: $cooldownMs
    counterMode: $counterMode
    youtubeVotesEnabled: $youtubeVotesEnabled
  ) {
    camControlId
    eventId
    name
    broadcasterUserIds
    commands {
      command
      count
    }
    changeLimit
    cooldownMs
    counterMode
    youtubeVotesEnabled
    status
    currentCommandIndex
    streak
    startedAt
    stoppedAt
    createdAt
    version
  }
}
